import axios from "axios"

//const HOST = process.env.VUE_APP_PROTOCOL + '://' + process.env.VUE_APP_IP + ":" + process.env.VUE_APP_PORT + "/hemaapi/api";
const HOST = process.env.VUE_APP_API + "/hemaapi/api"

const instance = axios.create({
  baseURL: HOST
})

/*instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
instance.defaults.timeout = 5000;*/

export { instance, HOST }
